<template>
  <div v-show="pricing" class="subscriptionModal" :class="subscriptionModalCustomClasses">
    <div class="subscriptionModal__limit__message" v-if="reachedMaxFreeSessions">
      Booking exceeds weekly free sessions limit.
      <!-- <a
        class="subscriptionModal__limit__message__link"
        href="https://www.cofocus.one/communities/cofocus/posts/62db92ad9460e1001657b917"
        target="_blank"
        >Learn more</a
      >. -->
    </div>

    <SubscriptionModalHeader @closeModal="closeSubscriptionModal" />
    <div class="subscriptionModal__body">
      <div class="subscriptionModal__body__perks">
        <SubscriptionModalBadge />
        <h2 class="subscriptionModal__body__perks__title">Unicorn Sparkle Club</h2>
        <div class="subscriptionModal__body__perks__option">
          <div class="subscriptionModal__body__perks__option__icon" style="background-color: #dce5ff">🚀</div>
          <div class="subscriptionModal__body__perks__option__contents">
            <div class="subscriptionModal__body__perks__option__title">Unlimited sessions</div>
            <div class="subscriptionModal__body__perks__option__description">Get as much accountability as you need.</div>
          </div>
        </div>
        <!--         <div class="subscriptionModal__body__perks__option">
          <div class="subscriptionModal__body__perks__option__icon" style="background-color: #d7efff">📈</div>
          <div class="subscriptionModal__body__perks__option__contents">
            <div class="subscriptionModal__body__perks__option__title">Session insights</div>
            <div class="subscriptionModal__body__perks__option__description">Get to know your usage statistics.</div>
          </div>
        </div>
        <div class="subscriptionModal__body__perks__option">
          <div class="subscriptionModal__body__perks__option__icon" style="background-color: #d7ffda">✅</div>
          <div class="subscriptionModal__body__perks__option__contents">
            <div class="subscriptionModal__body__perks__option__title">Tasks</div>
            <div class="subscriptionModal__body__perks__option__description">Manage your tasks both in-session and outside.</div>
          </div>
        </div> -->
        <div class="subscriptionModal__body__perks__option">
          <div class="subscriptionModal__body__perks__option__icon" style="background-color: #ede5ff">🦄</div>
          <div class="subscriptionModal__body__perks__option__contents">
            <div class="subscriptionModal__body__perks__option__title">Unicorn status</div>
            <div class="subscriptionModal__body__perks__option__description">You'll get the Unicorn Sparkle badge.</div>
            <!-- <div class="subscriptionModal__body__perks__option__description">You'll get a badge and unicorn next to your name.</div> -->
          </div>
        </div>
        <div class="subscriptionModal__body__perks__option">
          <div class="subscriptionModal__body__perks__option__icon" style="background-color: #ffe5e5">❤️</div>
          <div class="subscriptionModal__body__perks__option__contents">
            <div class="subscriptionModal__body__perks__option__title">Support the team</div>
            <div class="subscriptionModal__body__perks__option__description">Cofocus is bootstrapped and run by a small team.</div>
          </div>
        </div>
        <div class="subscriptionModal__body__perks__option" style="padding-bottom: 0px">
          <div class="subscriptionModal__body__perks__option__icon" style="background-color: #fff1d8">⭐</div>
          <div class="subscriptionModal__body__perks__option__contents">
            <div class="subscriptionModal__body__perks__option__title">Access to all future features</div>
            <div class="subscriptionModal__body__perks__option__description">Session insights, in-session tasks, and much more.</div>
          </div>
        </div>
      </div>
      <div class="subscriptionModal__plans">
        <div class="subscriptionModal__plans__option" @click="updateSelectedPlan('annual')">
          <div>
            <span class="subscriptionModal__plans__option__title">Annual Plan</span>
            <span class="subscriptionModal__plans__option__early">Save {{ getSavingsPercentage }}</span>
          </div>
          <div class="subscriptionModal__plans__option__price">{{ getAnnualPlanPriceMonthlyPreview }}/month</div>
          <div class="subscriptionModal__plans__option__price__summary">{{ getAnnualPlanPrice }}/year billed annually</div>
        </div>
        <div class="subscriptionModal__plans__option" @click="updateSelectedPlan('monthly')">
          <div>
            <span class="subscriptionModal__plans__option__title">Monthly Plan</span>
            <!-- <span class="subscriptionModal__plans__option__early">Early Bird</span> -->
          </div>
          <div class="subscriptionModal__plans__option__price">{{ getMonthlyPlanPrice }}/month</div>
          <div class="subscriptionModal__plans__option__price__summary">{{ getMonthlyPlanPriceAnnualPreview }}/year billed monthly</div>
        </div>
        <div class="subscriptionModal__plans__option__selected"></div>
      </div>
      <span class="subscriptionModal__plans__option__lifetime" @click="subscribeToLifetime">Lifetime Plan available for {{ getLifetimePrice }}</span>
    </div>
    <ELYXButton @click="createCheckoutSession">Subscribe ✨</ELYXButton>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ELYXButton from "../../ELYXComponents/ELYXButton.vue";
import SubscriptionMethods from "./SubscriptionMethods";
import SubscriptionModalHeader from "./SubscriptionModalHeader.vue";
import SubscriptionModalBadge from "./SubscriptionModalBadge.vue";
import { SubscriptionStore } from "../ELYXStore";
import { SharedSubscriptionConstants, SharedSubscriptionUtilities } from "@shared";

export default {
  components: {
    ELYXButton,
    SubscriptionModalHeader,
    SubscriptionModalBadge,
  },
  data() {
    return {
      chosenPlan: "annual",

      pricing: null,

      currencies: {
        usd: "$",
        eur: "€",
        inr: "₹",
      },

      currency: "usd",
      currencySymbol: "$",
    };
  },
  created() {
    this.setPricingVersion();
  },
  mounted() {
    SubscriptionMethods.initStripe();
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    reachedMaxFreeSessions: () => SubscriptionStore.state.reachedMaxFreeSessions,
    subscriptionModalCustomClasses() {
      if (this.reachedMaxFreeSessions && this.$windowHeight > 950) {
        return "subscriptionModal--topMessageSpacing";
      }
      if (this.reachedMaxFreeSessions && this.$windowHeight <= 950) {
        return "subscriptionModal--topMessageException";
      }
      return "";
    },

    monthlyPrice() {
      return this.pricing.monthly.prices[this.currency];
    },

    annualPrice() {
      return this.pricing.annual.prices[this.currency];
    },

    lifetimePrice() {
      return this.pricing.lifetime.prices[this.currency];
    },

    monthlyPlanAnnualPrice() {
      return this.monthlyPrice * 12;
    },

    annualPlanMonthlyPrice() {
      return this.annualPrice / 12;
    },

    getMonthlyPlanPrice() {
      return `${this.currencySymbol}${this.monthlyPrice.toFixed(2)}`; // should return $4.99
    },

    getAnnualPlanPrice() {
      return `${this.currencySymbol}${this.annualPrice.toFixed(0)}`; // should return $49
    },

    getLifetimePrice() {
      return `${this.currencySymbol}${this.lifetimePrice.toFixed(2)}`; // should return $89.99
    },

    getMonthlyPlanPriceAnnualPreview() {
      return `${this.currencySymbol}${this.monthlyPlanAnnualPrice.toFixed(2)}`; // should return $59.88
    },

    getAnnualPlanPriceMonthlyPreview() {
      return `${this.currencySymbol}${this.annualPlanMonthlyPrice.toFixed(2)}`; // should return $4.08
    },

    getSavingsPercentage() {
      const savingsPercentage = Math.round(100 - (this.annualPlanMonthlyPrice / this.monthlyPrice) * 100);
      return `${savingsPercentage}%`;
    },
  },
  methods: {
    setPricingVersion() {
      const isLegacyPremiumUser = SharedSubscriptionUtilities.isLegacyPremiumUser(this.user.subscription);
      const legacyPricingVersion = SharedSubscriptionUtilities.getLegacyPricingVersion(this.user.subscription);
      const currentPricingVersion = SharedSubscriptionConstants.currentPricingVersion;
      const pricingVersion = isLegacyPremiumUser ? legacyPricingVersion : currentPricingVersion;
      this.pricing = SharedSubscriptionConstants.pricing[pricingVersion];
    },

    updateSelectedPlan(plan) {
      const selection = document.querySelector(".subscriptionModal__plans__option__selected");
      if (plan === "annual") {
        selection.style.transform = "translateX(0%)";
      } else if (plan === "monthly") {
        selection.style.transform = "translateX(100%)";
      }
      this.chosenPlan = plan;
    },
    async createCheckoutSession() {
      window.mixpanel.track("Clicked Subscribe", {
        UID: this.user._id,
        userAgent: navigator.userAgent,
        chosenPlan: this.chosenPlan,
        page: window.location.href,
      });
      if (this.chosenPlan === "annual") {
        const annualPrice = this.getAnnualPriceID();
        await SubscriptionMethods.createCheckoutSession(annualPrice);
      } else if (this.chosenPlan === "monthly") {
        const monthlyPrice = this.getMonthlyPriceID();
        await SubscriptionMethods.createCheckoutSession(monthlyPrice);
      }
    },
    async subscribeToLifetime() {
      window.mixpanel.track("Clicked Lifetime Plan", {
        UID: this.user._id,
        userAgent: navigator.userAgent,
        chosenPlan: "lifetime",
        page: window.location.href,
      });
      const lifetimePrice = this.getLifetimePriceID();
      await SubscriptionMethods.createCheckoutSession(lifetimePrice);
    },

    getMonthlyPriceID() {
      return this.pricing.monthly.priceID;
    },

    getAnnualPriceID() {
      return this.pricing.annual.priceID;
    },

    getLifetimePriceID() {
      return this.pricing.lifetime.priceID;
    },

    closeSubscriptionModal: SubscriptionMethods.closeSubscriptionModal,
  },
};
</script>

<style scoped>
.subscriptionModal {
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  padding: 15px;
  width: 100%;
  max-width: 465px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  border-radius: 14px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.subscriptionModal--topMessageSpacing {
  margin-bottom: calc(-38px - 15px);
}
.subscriptionModal__limit__message {
  width: 465px;
  border-radius: 12px;
  text-align: center;
  margin: 0px auto;
  padding: 10px;
  box-sizing: border-box;
  line-height: 16px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  font-size: 16px;
  z-index: 1;
  background: #e7e2ff;
  border: 1px solid #8a6cfea8;
  position: absolute;
  top: calc(-38px - 15px);
  left: 0;
}
.subscriptionModal__limit__message__link {
  text-decoration: underline;
  text-underline-offset: 3px;
  margin-left: 5px;
  text-decoration-thickness: 1px;
  text-decoration-color: #555;
  cursor: pointer;
}
.subscriptionModal__limit__message__link:hover {
  color: #555;
  text-decoration-color: #888;
}
.subscriptionModal__body {
  display: flex;
  flex-direction: column;
}
.subscriptionModal__body__perks {
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  margin-top: 15px;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  padding: 15px;
  background: #ffffffa3;
  width: 100%;
  box-sizing: border-box;
}
.subscriptionModal__body__perks__title {
  margin: 15px auto;
  font-size: 19px;
  color: black;
  font-weight: 500;
}
.subscriptionModal__body__perks__option {
  display: flex;
  padding: 12px 0px;
  align-items: center;
}
.subscriptionModal__body__perks__option__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  font-size: 24px;
  margin-right: 15px;
  border-radius: 360px;
}
.subscriptionModal__body__perks__option__contents {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.subscriptionModal__body__perks__option__title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
}
.subscriptionModal__body__perks__option__description {
  color: #555;
  line-height: 18px;
  font-size: 15px;
}
.subscriptionModal__plans {
  display: flex;
  justify-content: center;
  width: calc(100%);
  margin: 10px auto;
  margin-bottom: 15px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background: #ffffff78;
  border-radius: 12px;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
}
.subscriptionModal__plans__option {
  width: 50%;
  border-radius: 12px;
  padding: 20px 15px;
  margin: 0px 5px;
  border: 1px solid transparent;
  cursor: pointer;
  background: transparent;
  z-index: 2;
}
.subscriptionModal__plans__option__title {
  font-size: 14px;
  color: #555;
}
.subscriptionModal__plans__option__early {
  border-radius: 12px;
  font-weight: 600;
  padding: 2px 6px;
  /* padding-right: 3px; */
  margin-left: 10px;
  font-size: smaller;
  background: linear-gradient(117deg, rgb(82 47 164) 0%, rgb(145 120 255) 35%, rgb(67 0 255) 100%);
  background: linear-gradient(117deg, rgb(47 94 164) 0%, rgb(126 120 255) 35%, rgb(168 147 255) 100%);
  color: #f4f2ff;
}
.subscriptionModal__plans__option__price {
  font-weight: 600;
  font-family: "Nunito";
  font-size: 18px;
  margin-top: 10px;
}
.subscriptionModal__plans__option__price__summary {
  font-size: 14px;
  margin-top: 8px;
  line-height: 16px;
  color: #555;
}
.subscriptionModal__plans__option__selected {
  background: #e7e2ff;
  border: 1px solid #8a6cfea8;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  padding: 20px 15px;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.3s cubic-bezier(0.6, -0.28, 0.21, 1.16);
  width: calc(50% - 5px);
  height: calc(100% - 10px);
  box-sizing: border-box;
  margin: 5px;
}
.subscriptionModal__plans__option__lifetime {
  text-align: center;
  margin-bottom: 15px;
  font-size: 15px;
  text-decoration: underline;
  color: #555;
  display: inline-block;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}
@media (max-width: 500px) {
  .subscriptionModal {
    max-width: unset;
    width: 100vw;
    border-radius: 0px;
  }
  .subscriptionModal__limit__message {
    width: 100%;
    border-radius: unset;
  }
}
@media (max-height: 795px) {
  .subscriptionModal {
    height: 100vh;
    overflow-y: scroll;
    border-radius: 0px;
  }
}
@media (max-height: 860px) {
  .subscriptionModal--topMessageException {
    height: 100vh;
    overflow-y: scroll;
  }
}
@media (max-height: 920px) {
  .subscriptionModal__limit__message {
    position: relative;
    top: unset;
    left: unset;
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
